import { AutoComplete, DatePicker, Form, Input, Select } from "antd";
import React, { createRef, useEffect, useRef, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search, select_id } from "../../../../Controllers/Global";
import moment from "moment";
import { get_product } from "../../../../Controllers/Products/Products";
import taxes from "../../../taxes.json";
import Error from "../../../../Componets/Error";

const Projectjobitemstable = React.forwardRef((props, focus) => {
  const { itemDetails, setItemDetails, itemTotals, setItemTotals } = props;

  const handleSearch = async (e, index) => {
    let data = [...itemDetails];

    const select = {
      api: "get-all-products",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({
          value: value?._id,
          label: value?.name,
        });
      });

      data[index].options = options;

      setItemDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handlePurchasePriceSearch = async (e, index) => {
    let data = [...itemDetails];

    if (data[index].description) {
      const select = {
        api: "get-all-inventory-details",
        id: data[index].description,
      };

      const search = await select_id(select);

      if (search?.status) {
        let options = [];
        search?.data?.map((value, index) => {
          options?.push({
            value: value?._id,
            label:
              value?.price_per_unit?.toFixed(3) +
              " #BATCH-" +
              value?.number +
              (value?.purchase?.number
                ? ` (${value?.purchase?.supplier?.name}, #PO-${
                    value?.purchase?.number
                  }, ${moment(value?.purchase?.date).format("DD/MM/YYYY")})`
                : ""),
          });
        });

        data[index].purchase_options = options;
        setItemDetails(data);
      } else {
        toast?.error(search?.message);
      }
    }
  };

  const handleDescription = async (e, index) => {
    let data = [...itemDetails];

    let params = {
      id: e,
    };
    const product = await get_product(params);

    if (product?.status) {
      let description_ids = [];
      data?.map((v, i) => {
        description_ids?.push(v?.description);
      });

      if (description_ids?.includes(product?.data?._id)) {
        let selected_index = description_ids?.indexOf(product?.data?._id);

        focus.current[`quantity${selected_index}`].current.focus();
      } else {
        let data_description = product?.data?._id;
        let data_name = product?.data?.name;
        let data_unit = product?.data?.unit?.name;
        let data_quantity = "";
        let data_purchase_price = "";
        let data_tax = 0;
        let data_tax_amount = 0;
        let data_total = "0.000";

        data[index].description = data_description;
        data[index].name = data_name;
        data[index].unit = data_unit;
        data[index].quantity = data_quantity;
        data[index].purchase_price = data_purchase_price;
        data[index].tax = data_tax;
        data[index].tax_amount = data_tax_amount;
        data[index].total = data_total;

        setItemDetails(data);

        focus.current[`quantity${index}`].current.focus();
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...itemDetails];

      let data_purchase_price = data[index]?.purchase_price
        ? data[index]?.purchase_price
        : 0;
      let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
      let data_tax = data[index]?.tax ? data[index]?.tax : 0;

      let purchase_price =
        name === "purchase_price" ? value : data_purchase_price;
      let quantity = name === "quantity" ? value : data_quantity;
      let tax = name === "tax" ? value : data_tax;

      let tax_amount = tax
        ? parseFloat(purchase_price) *
          parseFloat(quantity ? quantity : 1) *
          (parseFloat(tax) / 100)
        : 0;

      let total =
        parseFloat(purchase_price) * parseFloat(quantity ? quantity : 1) +
        parseFloat(tax_amount);

      data[index][name] = value;
      data[index].tax = tax ? tax : 0;
      data[index].tax_amount = tax_amount ? tax_amount?.toFixed(3) : 0;
      data[index].total = total ? total?.toFixed(3) : 0;
      data[index].tax_amount = tax_amount ? tax_amount?.toFixed(3) : 0;

      let subtotal =
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        ) -
        data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0
        );

      let taxamount = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount),
        0
      );

      let grandtotal = data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0
      );

      itemTotals.subtotal = subtotal;
      itemTotals.taxamount = taxamount;
      itemTotals.total = grandtotal;

      setItemDetails(data);
      setItemTotals({ ...itemTotals });
    }
  };

  const handleRemove = (index) => {
    let data = [...itemDetails];

    data?.splice(index, 1);

    setItemDetails(data);
  };

  const handleAdd = () => {
    let data = [...itemDetails];

    data?.push({
      id: "",
      description: null,
      unit: "",
      purchase_price: "",
      purchase_options: null,
      quantity: "",
      tax: 0,
      total: 0,
    });

    setItemDetails(data);

    setTimeout(() => {
      focus.current[`description${itemDetails?.length}`].current.focus();
    }, 200);
  };

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.No</td>
            <td className="border p-4 text-black">Description</td>
            <td className="border p-4 text-black">Unit</td>
            <td className="border p-4 text-black">Quantity</td>
            <td className="border p-4 text-black">Purchase price</td>
            <td className="border p-4 text-black">Tax</td>
            <td className="border p-4 text-black">Total</td>
            <td className="border p-4 text-black">Delete</td>
          </tr>
        </thead>
        <tbody>
          {itemDetails?.map((value, index) => {
            focus.current[`description${index}`] = createRef();
            focus.current[`quantity${index}`] = createRef();
            focus.current[`purchase_price${index}`] = createRef();

            return (
              <React.Fragment>
                <tr>
                  <td className="border p-4 ">{index + 1}</td>
                  <td className="border p-4">
                    {value?.description ? (
                      <div>{value?.name}</div>
                    ) : (
                      <Select
                        key={index}
                        className="w-[250px] text-regular"
                        name="description"
                        placeholder="Description"
                        ref={focus.current[`description${index}`]}
                        allowClear={true}
                        showSearch={true}
                        filterOption={false}
                        options={value?.options}
                        value={value?.description}
                        onFocus={(e) => handleSearch("", index)}
                        onSearch={(e) => handleSearch(e, index)}
                        onClick={(e) => handleSearch("", index)}
                        onChange={(e) => handleDescription(e, index)}
                        autoComplete="off"
                      />
                    )}
                    <Error id={`description${index}`} />
                  </td>
                  <td className="border p-4 ">{value?.unit}</td>
                  <td className="border p-4 ">
                    <Input
                      type="number"
                      className="w-[100px]"
                      name="quantity"
                      placeholder="Quantity"
                      ref={focus.current[`quantity${index}`]}
                      value={value?.quantity}
                      onChange={(e) => handleTotal(e, index)}
                      autoComplete="off"
                    />
                    <Error id={`quantity${index}`} />
                  </td>
                  <td className="border p-4">
                    <AutoComplete
                      className="w-[400px] text-regular"
                      name="purchase_price"
                      placeholder="Purchase price"
                      ref={focus.current[`purchase_price${index}`]}
                      allowClear={false}
                      showSearch={true}
                      filterOption={false}
                      options={value?.purchase_options}
                      value={value?.purchase_price}
                      onFocus={(e) => handlePurchasePriceSearch("", index)}
                      onSearch={(e) => handlePurchasePriceSearch(e, index)}
                      onClick={(e) => handlePurchasePriceSearch("", index)}
                      onChange={(e) => handleTotal(e, index, "purchase_price")}
                      autoComplete="off"
                    />
                    <Error id={`purchase_price${index}`} />
                  </td>
                  <td className="border p-4">
                    <div className="flex">
                      <div>
                        <Select
                          className="w-[100px] text-regular"
                          name="tax"
                          placeholder="Tax"
                          options={taxes}
                          value={value?.tax}
                          onChange={(e) => handleTotal(e, index, "tax")}
                        />
                      </div>
                      <div className="pl-2">{value?.tax_amount}</div>
                    </div>
                  </td>
                  <td className="border p-4 text-center">
                    {parseFloat?.(value?.total)?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-center" colSpan={3}>
              <AddButton onClick={handleAdd} />
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4">Subtotal</td>
            <td className="border p-4" colSpan={2}>
              {itemTotals?.subtotal > 0
                ? itemTotals?.subtotal?.toFixed(3)
                : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4">Tax&nbsp;amount</td>
            <td className="border p-4" colSpan={2}>
              {itemTotals?.taxamount > 0
                ? itemTotals?.taxamount?.toFixed(3)
                : "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-black text-medium">Total</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {itemTotals?.total > 0 ? itemTotals?.total?.toFixed(3) : "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default Projectjobitemstable;
